














import { useDeps } from '~/compositions/dependency-container'
import { Facet } from '~/models/search/types'
import ClassifiedSearchFacetsComponentsService from '~/services/search/ClassifiedSearchFacetsComponentsService'
import LegacySearchService from '~/services/search/LegacySearchService'
import { defineComponent, PropType, computed } from '~/utils/nuxt3-migration'
import { useNamespacedStore } from '~/compositions/store'
import { CLASSIFIED_SEARCH_NS } from '~/store/modules/shared/classifieds/search/state'

export default defineComponent({
  props: {
    facet: {
      type: Object as PropType<Facet>,
      required: true
    }
  },
  setup(props) {
    const [
      legacySearchService,
      classifiedSearchFacetsComponentsService
    ] = useDeps(LegacySearchService, ClassifiedSearchFacetsComponentsService)
    const {
      state: classifiedSearchState,
      getters: classifiedSearchGetters
    } = useNamespacedStore(CLASSIFIED_SEARCH_NS)

    const showCategoryPicker = computed(() =>
      classifiedSearchGetters('showCategoryPicker')
    )

    const loadingFacets = computed(() => classifiedSearchState.loading.facets)

    const facetHandler = computed(() =>
      classifiedSearchFacetsComponentsService.getFacetComponent(
        props.facet.type
      )
    )

    const facetBindings = computed(() =>
      legacySearchService.getFacetComponentBindings(props.facet)
    )

    const showFacet = computed(() => {
      if (props.facet.name === 'category') {
        return !showCategoryPicker.value
      }

      return props.facet.visible && facetHandler.value
    })

    return {
      loadingFacets,
      facetHandler,
      facetBindings,
      showFacet
    }
  }
})
